/*
 * 商品詳細（PC）の追従する商品情報が画面より高いとき、下端で止まるようにする。
 * Atelier標準は上端（ヘッダー直下）で固定するため、はみ出た下部（仕様など）が
 * 左の画像を最後までスクロールするまで見えない。
 * 高さが画面に収まらない場合だけ top を負の値にし、ページと一緒に下まで流れてから
 * 最後の行が見えた位置で止める。収まる場合は標準どおり上端で固定する。
 */
(() => {
  const BOTTOM_GAP = 24;
  const desktop = window.matchMedia('(min-width: 750px)');
  const details = document.querySelectorAll('.product-details.sticky-content--desktop');
  if (!details.length) return;

  // 画面下に出る「カートに追加する」バーと重ならないよう、その分の余白も空ける。
  const bottomReserve = () => {
    const bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return BOTTOM_GAP;
    const barBottom = parseFloat(getComputedStyle(bar).bottom) || 0;
    return bar.offsetHeight + barBottom + BOTTOM_GAP;
  };

  const update = (el) => {
    el.style.removeProperty('top');
    if (!desktop.matches) return;
    const baseTop = parseFloat(getComputedStyle(el).top) || 0;
    const overflow = baseTop + el.offsetHeight + bottomReserve() - window.innerHeight;
    if (overflow > 0) el.style.top = `${baseTop - overflow}px`;
  };

  const updateAll = () => details.forEach(update);

  // アコーディオンの開閉やフォント読み込みで高さが変わったときも追従する。
  const observer = new ResizeObserver(updateAll);
  details.forEach((el) => observer.observe(el));
  window.addEventListener('resize', updateAll);
  desktop.addEventListener('change', updateAll);
  updateAll();
})();
